import React, { Component } from 'react';
import TopBarLoggedIn from './TopBarLoggedIn';
import SideBar from './SideBar';
import Content from './Content';

class Main extends Component {
  constructor(props) {
    super(props)
    this.state = {
      persistentOpen: true
    }
    this.handleSidebarToggle = this.handleSidebarToggle.bind(this)
  }

  
  componentDidMount() {
    let open = true
    if(window.innerWidth <= 750){
      open = false
    }

    this.setState({persistentOpen: open});
  }

  handleSidebarToggle(){
    this.setState({
      persistentOpen: !this.state.persistentOpen
    })
  }

  render() {
    return (
    <div id="main">
      <TopBarLoggedIn toggleSidebar={this.handleSidebarToggle} />
      <div className="content-container">
        <SideBar menuState={this.state.persistentOpen} />
        <Content/>
        </div>
    </div>
    )
  }
}
export default Main



// WEBPACK FOOTER //
// ./src/layout/Main.jsx